import { Grid, Box } from "@mui/material";
import Appointment from "../interface/appointment";
import React from "react";
import { AppointmentOverviewContext } from "../context/appointmentOverviewContext";
import RenderTimeSlot from "./renderTimeSlot";
import RenderAppointmentActions from "./renderAppointmentActions";
import RenderAppointmentStatus from "./renderAppointmentStatus";
import RenderCollapse from "./renderCollapse";
import RenderParticipantFullName from "./renderParticipantFullName";
import RenderCoachFullName from "./renderCoachFullName";
import RenderSpeedCoachingText from "./renderSpeedCoachingText";

const AppointmentOverviewListTile = ({
  appointment,
}: {
  appointment: Appointment;
}): React.JSX.Element => {
  const {
    getBackgroundColor,
  }: {
    getBackgroundColor: (appointment: Appointment) => string;
  } = React.useContext(AppointmentOverviewContext);

  return (
    <Box
      sx={{
        mb: 1,
        backgroundColor: getBackgroundColor(appointment),
        borderRadius: 2,
        px: 2,
        py: 1,
      }}
    >
      <Grid container key={appointment.id}>
        <RenderTimeSlot appointment={appointment} />

        {appointment.isSpeedcoaching ? (
          <RenderSpeedCoachingText />
        ) : (
          <RenderParticipantFullName appointment={appointment} />
        )}

        <RenderCoachFullName appointment={appointment} />
        <RenderAppointmentStatus appointment={appointment} />
        <RenderAppointmentActions appointment={appointment} />
        <RenderCollapse appointment={appointment} />
      </Grid>
    </Box>
  );
};

export default AppointmentOverviewListTile;
